import Banner from "../../sections/common/banner";
import ItodoImage from "../../elements/itodo-img";
import { bannerData } from "../../../globals/banner";
import { NavLink } from "react-router-dom";

function TeamPage() {
  return (
    <>
      <Banner _data={bannerData.team} />

      <div className="section-full p-t110 p-b80 sx-bg-light sx-ourteam-outer ">
        <div className="container">
          {/* TITLE START */}
          <div className="section-head center">
            <div className="sx-head-s-title"></div>
            <div className="sx-head-l-title">
              <h2 className="sx-title">Azown Technology Team Members</h2>
            </div>
          </div>
          {/* TITLE END */}
          <div className="section-content">
            <div className="row sx-our-team-section">
              {/*1*/}
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="our-team-2">
                  <div className="profile-image">
                    <NavLink to="/team/venkatesh-chavan">
                      <ItodoImage src="images/our-team5/venkatesh.jpg" alt="The Azown Technology team collaborating on creative IT solutions and strategies." />
                    </NavLink>
                    <div className="icons">
                      <a href="https://www.facebook.com/share/15f8AYE5s3/">
                        <i className="fa fa-facebook" />
                      </a>
                      <a href="https://www.instagram.com/azown_technology/profilecard/?igsh=MWtuZ3Y1OGsxNWFhMg==">
                        <i className="fa fa-instagram" />
                      </a>
                    </div>
                  </div>
                  <div className="figcaption">
                    <p>Founder & Director</p>
                    <h4 className="sx-title">
                      <NavLink to="/team/venkatesh-chavan">
                        Venkatesh Chavan
                      </NavLink>
                    </h4>
                  </div>
                </div>
              </div>
              {/*2*/}
              
              {/*3*/}
              
              {/*5*/}
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="our-team-2">
                  <div className="profile-image">
                    <NavLink to="/team/mukta-chavan">
                      <ItodoImage src="images/our-team5/Mukta.png" alt="The Azown Technology team collaborating on creative IT solutions and strategies." />
                    </NavLink>
                    <div className="icons">
                      <a href="https://www.facebook.com/share/15f8AYE5s3/">
                        <i className="fa fa-facebook" />
                      </a>
                      <a href="https://www.instagram.com/azown_technology/profilecard/?igsh=MWtuZ3Y1OGsxNWFhMg==">
                        <i className="fa fa-instagram" />
                      </a>
                    </div>
                  </div>
                  <div className="figcaption">
                    <p>Director</p>
                    <h4 className="sx-title">
                      <NavLink to="/team/mukta-chavan">
                      Mukta Chavan
                      </NavLink>
                    </h4>
                  </div>
                </div>
              </div>
              {/*16*/}
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="our-team-2">
                  <div className="profile-image">
                    <NavLink to="/team/karan-dhole">
                      <ItodoImage src="images/our-team5/ " alt="The Azown Technology team collaborating on creative IT solutions and strategies." />
                    </NavLink>
                    <div className="icons">
                      <a href="#">
                        <i className="fa fa-facebook" />
                      </a>
                      <a href="#">
                        <i className="fa fa-instagram" />
                      </a>
                    </div>
                  </div>
                  <div className="figcaption">
                    <p>Web Developer</p>
                    <h4 className="sx-title">
                      <NavLink to="/team/karan-dhole">Karan Dhole</NavLink>
                    </h4>
                  </div>
                </div>
              </div>
                         </div>
          </div>
        </div>

        {/*Pagination*/}
        {/* <div className="sx-pagination-wra text-center">
                    <ul className="sx-pagination">
                        <li><a href="/#"><span className="fa fa-long-arrow-left" /></a></li>
                        <li><a href="/#">01</a></li>
                        <li className="active"><a href="/#">02</a></li>
                        <li><a href="/#">03</a></li>
                        <li><a href="/#">04</a></li>
                        <li><a href="/#"><span className="fa fa-long-arrow-right" /></a></li>
                    </ul>
                </div> */}
        {/*Pagination*/}
      </div>
    </>
  );
}

export default TeamPage;
